import type { Tool } from "@repo/app-types/entities/tool";
import { Button, ButtonVariant } from "@repo/ui/Buttons/button";
import { Size } from "@repo/ui/helpers/helpers";
import { SimpleMenu } from "@repo/ui/Menu/simpleMenu";
import { SimpleMenuItem } from "@repo/ui/Menu/simpleMenuItem";
import { SimpleMenuPopover } from "@repo/ui/Menu/simpleMenuPopover";
import { IconPlus } from "@tabler/icons-react";
import type { FC } from "react";
import { Collection, MenuTrigger } from "react-aria-components";

export interface AddToolMenuProps {
  /** Tools that are not yet assigned to the agent */
  availableTools: readonly Tool[];
  onSelectTool: (tool: Tool) => void;
  isDisabled?: boolean;
}

export const AddToolMenu: FC<AddToolMenuProps> = ({
  availableTools,
  onSelectTool,
  isDisabled,
}) => {
  // Don't show the button if there are no tools available to add
  if (availableTools.length === 0) {
    return null;
  }

  return (
    <MenuTrigger>
      <Button
        variant={ButtonVariant.Secondary}
        size={Size.MEDIUM}
        icon={<IconPlus className="h-4 w-4" />}
        isDisabled={isDisabled}
      >
        Add tool
      </Button>
      <SimpleMenuPopover>
        <SimpleMenu aria-label="Available tools">
          <Collection items={availableTools}>
            {(item) => (
              <SimpleMenuItem
                key={item.id}
                textValue={item.name}
                onAction={() => onSelectTool(item)}
              >
                {item.name}
              </SimpleMenuItem>
            )}
          </Collection>
        </SimpleMenu>
      </SimpleMenuPopover>
    </MenuTrigger>
  );
};
